import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { useMockedUser } from 'lib-mui-template';

import { hideScroll } from 'lib-mui-template';

import {Logo} from 'lib-mui-template';
import { NavSectionMini } from 'lib-mui-template';

import { NAV } from '../config-layout';
import NavToggleButton from '../common/nav-toggle-button';
import { NavConfig } from '../dashboard/types';

// ----------------------------------------------------------------------
type Props = {
  navConfig: NavConfig;
};


export default function NavMini({navConfig}:Props) {
  const { user } = useMockedUser();

  // const navData = useNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini
          data={navConfig.navStructure}
          slotProps={{
            currentRole: user?.role,
          }}
        />
      </Stack>
    </Box>
  );
}
